import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  faBooks,
  faCardsBlank,
  faInfo,
  faMinus,
  faPlus,
  faQuestion,
  faXmarkCircle
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useGetAssignmentVocabularyMutation } from '../../../../../features/authentication/assignApiSlice';
import DropDown from '../../../../../components/DropDown';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import CustomToast from '../../../../../components/Toast';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import appConfig from '../../../../../app-config';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from '../../../../../features/authentication/authSlice';

const VocabularyPrinting = () => {
  const location = useLocation();
  const { assignmentId, assignmentName } = location.state;
  const [assignmentVocabulary] = useGetAssignmentVocabularyMutation();
  const [vocabulary, setVocabulary] = useState({});
  const [vocabularyData, setVocabularyData] = useState([]);
  const [selectedFontStyle, setSelectedFontStyle] = useState();
  const [fontStyleClass, setFontStyleClass] = useState('times');
  const [imageCompressionValue, setImageCompressionValue] = useState(50);
  const [showName, setShowName] = useState(false);
  const [showTeacherName, setShowTeacherName] = useState(false);
  const [showDefinitions, setShowDefinitions] = useState(true);
  const [twoColumns, setTwoColumns] = useState(false);
  const [displayTopValue, setDisplayTopValue] = useState('');
  const baseUrl = appConfig.apiBaseUrl;
  const accessToken = useSelector(selectCurrentToken);
  let [count, setCount] = useState(12);
  const minCount = 10;
  const maxCount = 24;
  const [isPdfGenerating, setIsPdfGenerating] = React.useState(false);

  const fontStyle = [
    {
      id: 'default',
      name: 'Default'
    },
    {
      id: 'arial',
      name: 'Arial'
    },
    {
      id: 'comic Sans MS',
      name: 'Comic Sans'
    },
    {
      id: 'Courier',
      name: 'Courier'
    },
    {
      id: 'Tahoma',
      name: 'Tahoma'
    },
    {
      id: 'Times New Roman',
      name: 'Times New Roman'
    },
    {
      id: 'Verdana',
      name: 'Verdana'
    }
  ];

  const handleBackButtonClick = () => {
    window.history.back();
  };

  const getAssignmentVocabularyAsync = async () => {
    const options = {
      assignmentId: assignmentId
    };
    const getAssignmentVocabularyresponse = await assignmentVocabulary(options).unwrap();
    setVocabulary(getAssignmentVocabularyresponse);
    setVocabularyData(getAssignmentVocabularyresponse.vocabularyInfo);
  };

  const handleFontStyle = (event) => {
    const font = event.target.value;
    setSelectedFontStyle(font);
    switch (font) {
    case 'Times New Roman':
      setFontStyleClass('times');
      break;
    case 'arial':
      setFontStyleClass('arial');
      break;
    case 'comic Sans MS':
      setFontStyleClass('comic-sans');
      break;
    case 'Courier':
      setFontStyleClass('courier');
      break;
    case 'Tahoma':
      setFontStyleClass('tahoma');
      break;
    case 'Verdana':
      setFontStyleClass('verdana');
      break;
    default:
      setFontStyleClass('times');
      break;
    }
  };

  const incrementCount = () => {
    if (count < maxCount) {
      setCount((prevCount) => prevCount + 1);
    }
  };

  const decrementCount = () => {
    if (count > minCount) {
      setCount((prevCount) => prevCount - 1);
    }
  };

  const onSliderChange = (value) => {
    setImageCompressionValue(value);
  };

  const handleNameLine = () => {
    setShowName(!showName);
  };

  const handleTeacherName = () => {
    setShowTeacherName(!showTeacherName);
  };

  const handleDefinitions = () => {
    setShowDefinitions(!showDefinitions);
  };

  const handleColumns = () => {
    setTwoColumns(!twoColumns);
  };

  const handleDisplayTopValue = (event) => {
    const displayData = event.target.value;
    setDisplayTopValue(displayData);
  };

  const handleVocabularySelect = (event) => {
    const { name, checked } = event.target;
    if (name === 'selectAll') {
      const data = vocabularyData.map((item) => {
        return { ...item, isChecked: checked };
      });
      setVocabularyData(data);
    } else {
      let vocabularyArray = vocabularyData.map((item, index) =>
        `vocabulary${index}` === name ? { ...item, isChecked: checked } : item
      );
      setVocabularyData(vocabularyArray);
    }
  };

  const handleClearAll = () => {
    const data = vocabularyData.map((item) => {
      return { ...item, isChecked: false };
    });
    setVocabularyData(data);
  };

  const handleReset = () => {
    setSelectedFontStyle('default');
    setFontStyleClass('times');
    setCount(12);
    setShowName(false);
    setShowTeacherName(false);
    setShowDefinitions(true);
    setTwoColumns(false);
  };

  const handlePrintPDF = async () => {
    // Generate the PDF from the HTML content
    const contentWrapper = document.getElementById('vocabulary-data');

    const contentClone = contentWrapper.cloneNode(true);
    // const tables = contentClone.getElementsByTagName('table');

    const buttons = contentClone.querySelector('#checkData');
    const datas = contentClone.querySelectorAll('.doNotPrint');
    const checkboxes = contentClone.querySelectorAll('.checkboxes');
    const itemsBorder = contentClone.querySelectorAll('.check-items-border');
    const itemsNoBorder = contentClone.querySelectorAll('.check-items');

    buttons.style.display = 'none';
    datas.forEach((element) => {
      element.classList.add('d-none');
    });

    checkboxes.forEach((element) => {
      element.style.display = 'none';
    });

    itemsNoBorder.forEach((element) => {
      element.style.border = 'none';
      element.style.display = 'none';
    });

    itemsBorder.forEach((element) => {
      element.style.borderBottom = '1px dashed #E2E2E2';
    });

    const base64Encoded = btoa(unescape(encodeURIComponent(contentClone.innerHTML)));

    if (itemsBorder.length > 0) {
      setIsPdfGenerating(true);

      fetch(`${baseUrl}/PdfGenerator`, {
        method: 'POST',
        body: JSON.stringify({
          htmlContent: base64Encoded,
          OutputFileName: 'VocabularyPrint',
          PageSize: 3
        }),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        },
        mode: 'cors',
        credentials: 'include'
      })
        .then((response) => response.blob())
        .then((blob) => {
          if (blob.type === 'application/pdf') {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            const fileName = `${assignmentName}_${assignmentId}.pdf`;
            link.download = fileName;
            link.href = url;
            link.click();
            URL.revokeObjectURL(url);
          } else {
            CustomToast('Error ocuurred while generating pdf.', 'error');
          }
          setIsPdfGenerating(false);
        })
        .catch((error) => {
          console.error(error);
          setIsPdfGenerating(false);
        });
    } else {
      CustomToast('Select atleast one.', 'info');
    }
  };

  useEffect(() => {
    getAssignmentVocabularyAsync();
  }, []);

  return (
    <div className="vocabulary-container">
      <div className="vocabulary-header row">
        <div className="col-lg-9">
          <div className="vocabulary-heading mb-4">
            <div className="d-flex align-items-center justify-content-between p-4">
              <h3>Display/Print Vocabulary</h3>
              <div className="align-items-center btn-wrapper d-flex">
                <button className="btn flashcard-btn d-flex gap-2 d-none">
                  <FontAwesomeIcon icon={faCardsBlank} /> Create Flash Card
                </button>
                <button className="btn studyset-btn d-flex gap-2 d-none">
                  <FontAwesomeIcon icon={faBooks} /> Create Study Set
                </button>
                <button className="btn btn-castleWhite back-btn" onClick={handleBackButtonClick}>
                  Back
                </button>
              </div>
            </div>
          </div>
          <div className="vocabulary-content">
            <div className="vocabulary-content-scroll">
              <div id="vocabulary-data">
                <div className="vocabulary-content-data">
                  <div className={`${fontStyleClass} content-${count}`}>
                    {displayTopValue.length > 0 && (
                      <h3 className={`my-4 text-center content-${count}`}>{displayTopValue}</h3>
                    )}
                    <div>
                      <label>
                        <b>Assignment Name:</b> {assignmentName}
                      </label>
                    </div>
                    {(showName || showTeacherName) && (
                      <div className="name-slip">
                        <div className="d-flex align-items-center justify-content-between row">
                          <div className="col-lg-6">
                            {showName && (
                              <div>
                                <label className="form-label">Name:</label>
                                <input className="input-name" disabled></input>
                              </div>
                            )}
                          </div>
                          <div className="col-lg-6">
                            {showTeacherName && (
                              <div className="d-flex gap-2 align-items-center flex-row-reverse">
                                <label className="form-label teacher-name">
                                  Teacher: <span>{vocabulary.teacherName}</span>
                                </label>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="name-slip py-4 row" id="checkData">
                      <div className="col-lg-6 d-flex align-items-center gap-5 d-flex">
                        <div className="d-flex gap-2">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            name="selectAll"
                            checked={vocabularyData?.every((item) => item.isChecked)}
                            onChange={handleVocabularySelect}
                          />{' '}
                          <label className="form-label mb-0">Check All</label>
                        </div>
                        <div className="d-flex align-items-center">
                          <button className="clear-btn" name="clearAll" onClick={handleClearAll}>
                            <FontAwesomeIcon icon={faXmarkCircle} className="close-mark" />
                            Clear All
                          </button>
                        </div>
                      </div>
                      <div className="col-lg-6 d-flex flex-row-reverse">
                        <div className="d-flex gap-1 align-items-center info-box">
                          <FontAwesomeIcon icon={faInfo} className="info-icon" />
                          <span>
                            Check the items you want to print then expand the Format for Printing
                            option
                          </span>{' '}
                        </div>
                      </div>
                    </div>
                    <div className={`${twoColumns ? 'row' : ''}`}>
                      {vocabularyData?.map((item, index) => (
                        <div
                          key={index}
                          className={`check-items d-flex gap-2 py-4 ${twoColumns ? 'col-6' : ''} ${
                            !item?.isChecked ? 'doNotPrint' : 'printData check-items-border'
                          }`}>
                          <div>
                            <input
                              type="checkbox"
                              className="form-check-input checkboxes"
                              name={`vocabulary${index}`}
                              checked={!!item?.isChecked}
                              onChange={handleVocabularySelect}
                            />
                          </div>
                          <div className={`${!item?.isChecked ? 'doNotPrint' : 'printData'}`}>
                            <div
                              className="topic"
                              dangerouslySetInnerHTML={{
                                __html: item.name
                              }}></div>
                            {showDefinitions && (
                              <div
                                className="description"
                                dangerouslySetInnerHTML={{
                                  __html: item.description
                                }}></div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="vocabulary-settings">
            <h3 className="my-2">Print Options</h3>
            <div className="mb-2">
              <label className="form-label">Assignment Name</label>
              <input type="text" className="form-control" value={assignmentName} disabled />
            </div>
            <div className="mb-2">
              <label className="form-label">
                Text to display at the top of the vocabulary study sheet
              </label>
              <textarea
                className="form-control"
                value={displayTopValue}
                onChange={handleDisplayTopValue}></textarea>
            </div>
            <div className="row">
              <div className="col my-4">
                <DropDown
                  label="Font"
                  value={fontStyle}
                  onChangeHandler={handleFontStyle}
                  selectedValue={selectedFontStyle}
                />
              </div>
              <div className="col my-4">
                <label className="form-label">Font Size</label>
                <div className="col">
                  <div className="d-flex gap-2 align-items-center counter-wrapper">
                    <div className="btn counter-btn" onClick={decrementCount}>
                      <FontAwesomeIcon icon={faMinus} className="counter-icon" />
                    </div>
                    <div className="counter">{count}</div>
                    <div className="btn counter-btn" onClick={incrementCount}>
                      <FontAwesomeIcon icon={faPlus} className="counter-icon" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="checkbox-wrapper">
              <div className="d-flex gap-2">
                <input
                  type="checkbox"
                  className=" form-check-input"
                  onChange={handleNameLine}
                  checked={`${showName ? 'checked' : ''}`}
                />{' '}
                <label className="form-label">Show name line</label>
              </div>
              <div className="d-flex gap-2">
                <input
                  type="checkbox"
                  className=" form-check-input"
                  onChange={handleTeacherName}
                  checked={`${showTeacherName ? 'checked' : ''}`}
                />{' '}
                <label className="form-label">Show teacher name</label>
              </div>
              <div className="d-flex gap-2">
                <input
                  type="checkbox"
                  className=" form-check-input"
                  onChange={handleDefinitions}
                  checked={`${!showDefinitions ? 'checked' : ''}`}
                />{' '}
                <label className="form-label">Hide definitions</label>
              </div>
              <div className="separator my-2"></div>
              <div className="d-flex gap-2">
                <input
                  type="checkbox"
                  className=" form-check-input"
                  onChange={handleColumns}
                  checked={`${twoColumns ? 'checked' : ''}`}
                />{' '}
                <label className="form-label">Two columns</label>
              </div>
            </div>
            <div className="slider pb-5">
              <div className="d-flex row slider-label">
                <label className="form-label d-flex gap-2 col">
                  <span>Image compression</span>
                  <OverlayTrigger
                    key="image-overlay"
                    placement="left"
                    overlay={
                      <Tooltip className="image-info-tooltip">
                        <div>
                          <p>
                            Selecting two-column printing can reduce the number of pages that are
                            printed. It may be necessary to shrink some images in order to fit them
                            into a column. This might make the image unreadable.
                          </p>
                          <p>
                            The compression image option allows you to specify how much images can
                            be compressed. Often, 20% is a good choice but depending on what is in
                            the graphic you may be able to use a higher percentage or need to use a
                            lower value. The page will not use columns if the images will not fit
                            using the specified compression value.
                          </p>
                        </div>
                      </Tooltip>
                    }>
                    <FontAwesomeIcon icon={faQuestion} className="question-icon" />
                  </OverlayTrigger>
                </label>
                <input
                  type="text"
                  value={`${imageCompressionValue}%`}
                  className="form-control col flex-row-reverse"
                  readOnly
                />
              </div>
              <div className="sliding-bar">
                <Slider
                  min={0}
                  max={100}
                  value={imageCompressionValue}
                  onChange={onSliderChange}
                  marks={{ 0: '0%', 100: '100%' }}
                />
              </div>
            </div>
            <div className="submit-buttons d-flex gap-2 my-4">
              <button className="btn btn-castleGray" onClick={handleReset}>
                Reset
              </button>
              <button
                className={`btn btn-castleRed ${isPdfGenerating ? 'disabled' : ''}`}
                onClick={handlePrintPDF}>
                {isPdfGenerating ? 'Generating PDF...' : 'Print to PDF'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VocabularyPrinting;
